// extracted by mini-css-extract-plugin
export default {"cta":"CTA_cta__lN954","container":"CTA_container__TPa1k","left":"CTA_left__UNXJA","phone":"CTA_phone__7VY3o","right":"CTA_right__3Ghx3","button":"CTA_button__Pl6B7"};